export default function (toRound, roundingMultiple) {
    return Math.ceil(toRound / roundingMultiple) * roundingMultiple;
}
